import React, { useEffect, useMemo, useState } from "react";
import getReq from "../interface/getRequestinterface";
import { getRequest, postRequest } from "../request";
import {
  Alert,
  AlertTitle,
  Button,
  ButtonGroup,
  IconButton,
  Modal,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TextField,
} from "@mui/material";
import { Box } from "@mui/system";
import { Delete, Edit, KeyboardReturn } from "@mui/icons-material";
import { CacheProvider } from "@emotion/react";
import rtlPlugin from "stylis-plugin-rtl";
import createCache from "@emotion/cache";
import { prefixer } from "stylis";
import { useNavigate } from "react-router-dom";
import postReq from "../interface/postRequestinterface";
import { toast } from "react-toastify";
import Loading from "./loading";
import { useMediaQuery } from "react-responsive";

const style = {
  gridBox: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    marginTop: "2rem",
  },
  modalShape: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    bgcolor: "background.paper",
    boxShadow: 24,
    pt: 2,
    px: 4,
    pb: 3,
  },
};
interface CharenseUser {
  id: number;
  userId: string;
  user_name: string;
  service_Id: number;
  is_Select: boolean;
  is_Used: true;
  date_Select: string;
  date_Used: string;
  requested_ID: string;
  service_name: string;
  level_ID: number;
  type_ID: number;
}
const levelType = ["طلایی", "نقره ای", "برنزی"];
function AdminCheckServices() {
  const [charenseUserList, setCharenseUserList] = useState<Array<CharenseUser>>(
    []
  );
  const [EditService, setEditService] = useState<number>(-1);
  const [DeleteService, setDeleteService] = useState<number>(-1);
  const [page, setPage] = useState(0);
  const [isOpenDeleteModal, setIsOpenDeleteModal] = useState<boolean>(false);
  const [isOpenEditModal, setIsOpenEditModal] = useState<boolean>(false);
  const [rowsPerPage, setRowsPerPage] = useState<number>(5);
  const [filteredItem, setFilteredItem] = useState<string>("");
  const navigate = useNavigate();
  useEffect(() => {
    getAllServices();
  }, []);
  const isDesktop = useMediaQuery({
    query: "(min-width: 1224px)",
  });

  const isTablet = useMediaQuery({
    query: "((min-width:650px) and (max-width: 900px))",
  });

  const isMobile = useMediaQuery({
    query: "(max-width: 400px)",
  });
  const cacheRtl = useMemo(() => {
    return createCache({
      key: "muirtl",
      stylisPlugins: [prefixer, rtlPlugin],
    });
  }, []);
  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  const getAllServices = async () => {
    const { data, error }: getReq = (await getRequest(
      `${process.env.REACT_APP_BASE_URL}/CharenseServices/List_Charense_Users`
    )) as getReq;
    if (!error) {
      setCharenseUserList(data);
    }
  };

  const submitChanges = async () => {
    const { data, error }: postReq = (await postRequest(
      `${process.env.REACT_APP_BASE_URL}/CharenseServices/Remove_Charense_Users?id=${DeleteService}`
    )) as postReq;
    if (!error) {
      toast.success("درخواست شما با موفقیت انجام شد!");
      navigate(0);
    } else {
      toast.error(error);
    }
  };
  const submitEdits = async () => {
    const { data, error }: postReq = (await postRequest(
      `${process.env.REACT_APP_BASE_URL}/CharenseServices/IsUsed_Charense_Users?id=${EditService}`
    )) as postReq;
    if (!error) {
      toast.success("درخواست شما با موفقیت انجام شد!");
      navigate(0);
    } else {
      toast.error(error);
    }
  };
  const handleReturn = () => {
    setEditService(-1);
    setIsOpenDeleteModal(false);
  };
  const handleReturnEdit = () => {
    setEditService(-1);
    setIsOpenEditModal(false);
  };
  const inputStyle = {
    color: "#fff", // Change this color to your desired color
    backgroundColor: "transparent", // Change this color to your desired background color
  };
  return (
    <CacheProvider value={cacheRtl}>
      <Box className="background">
        {charenseUserList.length ? (
          <Box sx={style.gridBox}>
            <Box>
              <Alert severity="success" sx={{ width: "fit-content" }}>
                <AlertTitle sx={{ fontWeight: "bold", fontSize: "2rem" }}>
                  لیست سرویس ها:
                </AlertTitle>
              </Alert>
            </Box>
            <Paper
              sx={{ width: "80%", mb: 2, marginTop: "2rem", overflowX: "auto" }}
            >
              <TableContainer
                component={Paper}
                sx={{
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <Box
                  sx={{
                    width: "100%",
                    overflowX: "auto",
                  }}
                >
                  <Table
                    aria-label="simple table"
                    sx={{
                      borderCollapse: "collapse",
                      width: "100%",
                    }}
                  >
                    <TableHead>
                      <TableRow>
                        <TableCell className="ratesTh" align="center">
                          <Box
                            sx={{ display: "flex", flexDirection: "column" }}
                          >
                            <TextField
                              size="small"
                              label="جستجو"
                              value={filteredItem}
                              onChange={(e) => setFilteredItem(e.target.value)}
                              sx={{
                                width: "10rem",
                                "& .MuiInputBase-root": {
                                  color: "#efefef",
                                },
                                "& .MuiFormLabel-root": {
                                  color: "#efefef",
                                },
                                "& .MuiFormLabel-root.Mui-focused": {
                                  color: "#efefef",
                                },

                                "& .MuiOutlinedInput-root": {
                                  "& .MuiAutocomplete-endAdornment": {
                                    color: "#efefef",
                                  },
                                  "& fieldset": {
                                    borderColor: "#efefef",
                                  },
                                  "&:hover fieldset": {
                                    borderColor: "#efefef",
                                  },
                                  "&.Mui-focused fieldset": {
                                    borderColor: "#efefef",
                                  },
                                },
                              }}
                            />
                            نام مشتری
                          </Box>
                        </TableCell>
                        <TableCell className="ratesTh" align="center">
                          نام سرویس
                        </TableCell>
                        <TableCell className="ratesTh" align="center">
                          سطح سرویس
                        </TableCell>
                        <TableCell className="ratesTh" align="center">
                          تایید/عدم تایید
                        </TableCell>
                        <TableCell className="ratesTh" align="center">
                          حذف
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {filteredItem.length
                        ? charenseUserList
                            .filter((user) =>
                              user.user_name
                                .toLowerCase()
                                .includes(filteredItem.toLocaleLowerCase())
                            )
                            .map((x, idx) => (
                              <TableRow
                                key={x.id}
                                className="ratesTr"
                                sx={{
                                  "&:last-child , &:last-child": { border: 0 },
                                }}
                              >
                                <TableCell className="ratesTd" align="center">
                                  {x.user_name}
                                </TableCell>
                                <TableCell className="ratesTd" align="center">
                                  {x.service_name}
                                </TableCell>
                                <TableCell className="ratesTd" align="center">
                                  {levelType[x.level_ID - 1]}
                                </TableCell>
                                <TableCell align="center">
                                  {x.is_Used ? (
                                    "فعال"
                                  ) : (
                                    <IconButton
                                      onClick={() => {
                                        setEditService(x.id);
                                        setIsOpenEditModal(true);
                                      }}
                                    >
                                      <Edit />
                                    </IconButton>
                                  )}
                                </TableCell>
                                <TableCell align="center">
                                  <IconButton
                                    onClick={() => {
                                      setDeleteService(x.id);
                                      setIsOpenDeleteModal(true);
                                    }}
                                  >
                                    <Delete />
                                  </IconButton>
                                </TableCell>
                              </TableRow>
                            ))
                        : charenseUserList
                            .slice(
                              page * rowsPerPage,
                              page * rowsPerPage + rowsPerPage
                            )
                            ?.map((x, idx) => (
                              <TableRow
                                key={x.id}
                                className="ratesTr"
                                sx={{
                                  "&:last-child , &:last-child": { border: 0 },
                                }}
                              >
                                <TableCell className="ratesTd" align="center">
                                  {x.user_name}
                                </TableCell>
                                <TableCell className="ratesTd" align="center">
                                  {x.service_name}
                                </TableCell>
                                <TableCell className="ratesTd" align="center">
                                  {levelType[x.level_ID - 1]}
                                </TableCell>
                                <TableCell align="center">
                                  {x.is_Used ? (
                                    "فعال"
                                  ) : (
                                    <IconButton
                                      onClick={() => {
                                        setEditService(x.id);
                                        setIsOpenEditModal(true);
                                      }}
                                    >
                                      <Edit />
                                    </IconButton>
                                  )}
                                </TableCell>
                                <TableCell align="center">
                                  <IconButton
                                    onClick={() => {
                                      setDeleteService(x.id);
                                      setIsOpenDeleteModal(true);
                                    }}
                                  >
                                    <Delete />
                                  </IconButton>
                                </TableCell>
                              </TableRow>
                            ))}
                    </TableBody>
                  </Table>
                </Box>
              </TableContainer>
              <TablePagination
                rowsPerPageOptions={[5, 10, 25]}
                labelRowsPerPage={"تعداد سطر ها"}
                component="div"
                count={charenseUserList.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
              />
            </Paper>
          </Box>
        ) : (
          <div
            style={{
              width: "100vw",
              height: "calc( 100vh - 64px)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Loading type="cylon" color="#000" />
          </div>
        )}
      </Box>
      <Modal
        open={isOpenDeleteModal}
        onClose={() => setIsOpenDeleteModal(false)}
      >
        <Box
          sx={
            isDesktop
              ? { ...style.modalShape, width: "30rem" }
              : { ...style.modalShape, width: "20rem" }
          }
        >
          <h2 id="parent-modal-title">از حذف سرویس مورد نظر مطمئن هستید؟</h2>
          <ButtonGroup sx={{ marginTop: "2rem" }}>
            <Button variant="contained" color="primary" onClick={submitChanges}>
              تایید
              <Delete />
            </Button>
            <Button
              variant="contained"
              color="secondary"
              onClick={handleReturn}
            >
              بازگشت
              <KeyboardReturn />
            </Button>
          </ButtonGroup>
        </Box>
      </Modal>
      <Modal open={isOpenEditModal} onClose={() => setIsOpenEditModal(false)}>
        <Box
          sx={
            isDesktop
              ? { ...style.modalShape, width: "30rem" }
              : { ...style.modalShape, width: "20rem" }
          }
        >
          <h2 id="parent-modal-title">
            از تغییر وضعیت سرویس مورد نظر مطمئن هستید؟
          </h2>
          <ButtonGroup sx={{ marginTop: "2rem" }}>
            <Button variant="contained" color="primary" onClick={submitEdits}>
              تایید
              <Edit />
            </Button>
            <Button
              variant="contained"
              color="secondary"
              onClick={handleReturnEdit}
            >
              بازگشت
              <KeyboardReturn />
            </Button>
          </ButtonGroup>
        </Box>
      </Modal>
    </CacheProvider>
  );
}

export default AdminCheckServices;
